import { useState, useEffect } from 'react';
import axios from 'axios';
import Layout from './Layout';
import '../styles.css';

import { API_URL } from '../config';
const LIVE_PRICE_ID = 'price_1QiHIIAEAam2bjfrRnedrCtA';

function Upgrade() {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubscribe = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      if (!token) throw new Error('No authentication token found');
      console.log('Sending priceId:', LIVE_PRICE_ID);
      const response = await axios.post(
        `${API_URL}/api/subscription/create-checkout-session`,
        { priceId: LIVE_PRICE_ID },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      console.log('Redirecting to Stripe:', response.data.url);
      window.location.href = response.data.url;
    } catch (err) {
      console.error('Subscription error:', err);
      setError(err.response?.data?.error || 'Server error');
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="container" style={{ maxWidth: '800px', margin: '0 auto', padding: '20px' }}>
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <h1 style={{ color: '#333', marginBottom: '20px' }}>Upgrade to Premium</h1>
          <p style={{ fontSize: '18px', color: '#666', marginBottom: '10px' }}>
            Unlock the full potential of True Devotion
          </p>
          <div style={{ 
            display: 'inline-block', 
            backgroundColor: '#28a745', 
            color: 'white', 
            padding: '8px 16px', 
            borderRadius: '20px',
            fontSize: '16px',
            fontWeight: 'bold'
          }}>
            $7.77/month
          </div>
        </div>

        {error && (
          <div style={{ 
            padding: '15px', 
            backgroundColor: '#f8d7da', 
            color: '#721c24', 
            borderRadius: '6px', 
            marginBottom: '20px',
            textAlign: 'center'
          }}>
            {error}
          </div>
        )}

        {/* Features Grid */}
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
          gap: '20px', 
          marginBottom: '40px' 
        }}>
          {/* Basic Features */}
          <div style={{ 
            padding: '25px', 
            backgroundColor: '#f8f9fa', 
            borderRadius: '8px',
            border: '1px solid #e9ecef'
          }}>
            <h3 style={{ color: '#333', marginBottom: '15px', textAlign: 'center' }}>Basic Features</h3>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
                <span style={{ color: '#28a745', fontSize: '18px', marginRight: '10px' }}>✓</span>
                Daily questions delivered to your inbox
              </li>
              <li style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
                <span style={{ color: '#28a745', fontSize: '18px', marginRight: '10px' }}>✓</span>
                Answer and save your partner's responses
              </li>
              <li style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
                <span style={{ color: '#28a745', fontSize: '18px', marginRight: '10px' }}>✓</span>
                Skip up to 7 questions per day
              </li>
              <li style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
                <span style={{ color: '#28a745', fontSize: '18px', marginRight: '10px' }}>✓</span>
                Browse your answer history
              </li>
              <li style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
                <span style={{ color: '#28a745', fontSize: '18px', marginRight: '10px' }}>✓</span>
                Complete privacy with encryption
              </li>
            </ul>
          </div>

          {/* Premium Features */}
          <div style={{ 
            padding: '25px', 
            backgroundColor: '#e3f2fd', 
            borderRadius: '8px',
            border: '2px solid #bbdefb',
            position: 'relative'
          }}>
            <div style={{
              position: 'absolute',
              top: '-10px',
              left: '50%',
              transform: 'translateX(-50%)',
              backgroundColor: '#1976d2',
              color: 'white',
              padding: '5px 15px',
              borderRadius: '15px',
              fontSize: '12px',
              fontWeight: 'bold'
            }}>
              PREMIUM
            </div>
            <h3 style={{ color: '#1976d2', marginBottom: '15px', textAlign: 'center', marginTop: '10px' }}>Premium Features</h3>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
                <span style={{ color: '#1976d2', fontSize: '18px', marginRight: '10px' }}>⭐</span>
                <strong>AI Relationship Advisor</strong> - Get personalized insights
              </li>
              <li style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
                <span style={{ color: '#1976d2', fontSize: '18px', marginRight: '10px' }}>⭐</span>
                <strong>Custom Questions</strong> - Create your own questions
              </li>
              <li style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
                <span style={{ color: '#1976d2', fontSize: '18px', marginRight: '10px' }}>⭐</span>
                <strong>Advanced Search</strong> - Find specific answers quickly
              </li>
              <li style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
                <span style={{ color: '#1976d2', fontSize: '18px', marginRight: '10px' }}>⭐</span>
                <strong>Edit & Delete</strong> - Manage your conversation history
              </li>
              <li style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
                <span style={{ color: '#1976d2', fontSize: '18px', marginRight: '10px' }}>⭐</span>
                <strong>Priority Support</strong> - Get help when you need it
              </li>
            </ul>
          </div>
        </div>

        {/* Benefits Section */}
        <div style={{ 
          padding: '25px', 
          backgroundColor: '#f8f9fa', 
          borderRadius: '8px',
          border: '1px solid #e9ecef',
          marginBottom: '40px'
        }}>
          <h3 style={{ color: '#333', marginBottom: '20px', textAlign: 'center' }}>Why Upgrade?</h3>
          <div style={{ display: 'grid', gap: '15px' }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '15px' }}>
              <span style={{ color: '#007bff', fontSize: '20px' }}>💡</span>
              <div>
                <strong>Deeper Understanding</strong> - AI insights help you understand your partner better
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '15px' }}>
              <span style={{ color: '#007bff', fontSize: '20px' }}>🎯</span>
              <div>
                <strong>Personalized Experience</strong> - Custom questions tailored to your relationship
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '15px' }}>
              <span style={{ color: '#007bff', fontSize: '20px' }}>🔍</span>
              <div>
                <strong>Better Organization</strong> - Find and manage your conversations easily
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '15px' }}>
              <span style={{ color: '#007bff', fontSize: '20px' }}>❤️</span>
              <div>
                <strong>Stronger Connection</strong> - Tools designed to bring you closer together
              </div>
            </div>
          </div>
        </div>

        {/* Subscribe Button */}
        <div style={{ textAlign: 'center' }}>
          <button
            onClick={handleSubscribe}
            disabled={loading}
            style={{
              padding: '16px 40px',
              backgroundColor: '#28a745',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: loading ? 'not-allowed' : 'pointer',
              fontSize: '18px',
              fontWeight: 'bold',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
              transition: 'all 0.2s ease',
              opacity: loading ? 0.7 : 1
            }}
            onMouseOver={(e) => !loading && (e.target.style.backgroundColor = '#218838')}
            onMouseOut={(e) => !loading && (e.target.style.backgroundColor = '#28a745')}
          >
            {loading ? 'Processing...' : 'Upgrade to Premium - $7.77/month'}
          </button>
          
          <p style={{ 
            marginTop: '15px', 
            fontSize: '14px', 
            color: '#666',
            fontStyle: 'italic'
          }}>
            Cancel anytime. No long-term commitment.
          </p>
        </div>
      </div>
    </Layout>
  );
}

export default Upgrade;